module.exports = __webpack_public_path__ + "static/media/loading3.18de6f07.webp";